import {SellerError} from './SellerError.js'

export class EmptyNameSellerError extends SellerError {}
